import { render, staticRenderFns } from "./activityExamUploadResult.html?vue&type=template&id=0122b503&scoped=true&external"
import script from "./activityExamUploadResult.vue?vue&type=script&lang=js"
export * from "./activityExamUploadResult.vue?vue&type=script&lang=js"
import style0 from "./activityExamUploadResult.css?vue&type=style&index=0&id=0122b503&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122b503",
  null
  
)

export default component.exports